import React from "react";

import { Card, CardContent } from "../../components/ui/card";
import InfoTooltip from "../../components/ui/InfoTooltip";
import { Label } from "../../components/ui/label";
import ListManager from "../../components/ListManager";
import MeetingManager from "../../components/MeetingManager";

const ProjectAdmin = ({ properties, setProperties }) => {
  const updateProperties = async (field, value) => {
    const updatedProperties = {
      ...properties,
      [field]: value,
    };

    setProperties(updatedProperties);
  };
  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <ListManager
          items={properties.disciplines}
          onAdd={(discipline) =>
            updateProperties("disciplines", [
              ...properties.disciplines,
              discipline,
            ])
          }
          onRemove={(index) =>
            updateProperties(
              "disciplines",
              properties.disciplines.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Disciplines</Label>

              <div className="relative group">
                <InfoTooltip text="Add disciplines that are part of your project for better Hazard allocation." />
              </div>
            </div>
          }
          placeholder="Add discipline..."
        />

        <ListManager
          items={properties.drawingPackages}
          onAdd={(package_) =>
            updateProperties("drawingPackages", [
              ...properties.drawingPackages,
              package_,
            ])
          }
          onRemove={(index) =>
            updateProperties(
              "drawingPackages",
              properties.drawingPackages.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Drawing Packages</Label>

              <div className="relative group">
                <InfoTooltip text="Add drawing packages that are part of your project for better Hazard allocation." />
              </div>
            </div>
          }
          placeholder="Add drawing package..."
        />

        <ListManager
          items={properties.mitigationOwners}
          onAdd={(owner) =>
            updateProperties("mitigationOwners", [
              ...properties.mitigationOwners,
              owner,
            ])
          }
          onRemove={(index) =>
            updateProperties(
              "mitigationOwners",
              properties.mitigationOwners.filter((_, i) => i !== index)
            )
          }
          label={
            <div className="flex items-center gap-2 relative">
              <Label>Project mitigation owners</Label>

              <div className="relative group">
                <InfoTooltip text="Add Mitigation Owners that are part of your project for better Hazard allocation." />
              </div>
            </div>
          }
          placeholder="Add mitigation owner..."
        />

        <div className="space-y-2">
          <h4 className="font-medium flex items-center gap-2">
            <Label>Project SiD/SSWG Meetings</Label>

            <div className="relative group">
              <InfoTooltip text="Add Safety in Design (SiD) or System Safety Working Group (SSWG) meetings for tracking project safety reviews and decisions." />
            </div>
          </h4>

          <MeetingManager
            meetings={properties.meetings}
            onAdd={(meeting) =>
              updateProperties("meetings", [...properties.meetings, meeting])
            }
            onRemove={(index) =>
              updateProperties(
                "meetings",
                properties.meetings.filter((_, i) => i !== index)
              )
            }
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectAdmin;
